<template>
  <div class="container">
    <header class="m-header-wrapper">
      <div class="m-header-container">
        <div class="logo-header-container half-border">
          <a class="logo" href="/"
            ><div class="tt-image all-border-box ios">
              <div
                class="image-container loaded animate"
                style="transition-duration: 200ms"
              >
                <img
                  class="image-content ios"
                  src="http://shenghuoribao.oss-cn-beijing.aliyuncs.com/logo.png"
                  alt="生活融媒"
                  style="object-fit: cover; object-position: center center"
                />
              </div></div
          ></a>
          <!-- <div class="search" role="button">
            <div class="search-icon"></div>
            <input
              class="search-input"
              type="text"
              placeholder="请输入搜索关键词"
              aria-label="搜索"
              readonly=""
              @click-left="$router.back()"
              @click-right="$router.push('/search')"
            />
          </div> -->
          <van-search
          class="search"
          v-model="keyword"
          show-action
          placeholder="请输入搜索关键词"
          @search="onSearch"
          />
    <!-- 输入关键词的时候=》显示=》联想词列表=> 猜测用户即将要搜索的关键词结果列表 -->
    <van-cell-group class="suggest-box" v-if="keyword">
      <!-- span高亮联想关键词 -->
      <!-- 最终目标就是联想建议也可以进行跳转搜索结果 跳转要把带span标签的数据再次替换-->
      <van-cell
        icon="search"
        @click="onSearch(sug.replace(`<span>${keyword}</span>`, keyword))"
        v-for="sug in suggestList"
        :key="sug"
        ><p v-html="sug"></p
      ></van-cell>
    </van-cell-group>
    <!-- 历史记录 -->
        </div>
      </div>
    </header>
    <!-- 中 -->
    <div class="my-wrapper" :class="{ noTop: $route.path === '/user' }">
      <router-view></router-view>
    </div>
    <!-- 下 -->
    <!-- <van-tabbar router v-model="active"> -->
      <div class="footer">
        <div><span class="logo-title">生活融媒</span><span class="version">版本 v1.0</span></div>
        <div><span class="beian">鲁ICP备2022007256号</span></div>
      </div>
      <!-- <van-tabbar-item to="/" icon="home-o">首页</van-tabbar-item> -->
      <!-- <van-tabbar-item to="/question" icon="search">问答</van-tabbar-item>
      <van-tabbar-item to="/video" icon="friends-o">视频</van-tabbar-item> -->
      <!-- <van-tabbar-item to="/user" icon="setting-o">我的</van-tabbar-item> -->
    <!-- </van-tabbar> -->
  </div>
</template>

<script>
export default {
  // created () {
  //   console.log('获取当前页面的path路径：', this.$route.path)
  // }
  data() {
    return {
      active: "home",
      keyword: '',
      suggestList: [],
      timer: null
    }
  },
  methods: {
     onSearch (val) {
      // /** 搜索事件回调==>手机端软键盘的回车或完成时会触发
      //  *历史记录 存储搜索关键词 ===> 排重
      //  * 跳转搜索结果也并携带当前搜索关键词
      // */
      // console.log(val, this.keyword)
      // if (!val) return
      // // New Set() 接受一个数组或类数组对象,在Set内部， NAN相等，两个对象不等，可以用length检测，可以用for...of遍历Set结构返回伪数组，用from展开或者...
      // const historySet = new Set(this.historyList)
      // historySet.add(val)
      // this.historyList = [...historySet]
      // localStorage.setItem(TT_HS, JSON.stringify(this.historyList))
      this.$router.push(`/search/result?q=${val}`)
    },
  },
  watch: {
    /** 用户实时输入=》会多次调用接口查找联想词列表
     * 浪费服务器资源
     * 公司成本
     * 防抖：解决高频发 ---所谓防抖，就是指触发事件后在 n 秒内函数只能执行一次，如果在 n 秒内又触发了事件，则会重新计算函数执行时间。
     * 所谓节流，就是指连续触发事件但是在 n 秒中只执行一次函数。节流会稀释函数的执行频率。对于节流，一般有两种方式可以实现，分别是时间戳版和定时器版
     *模拟防抖：
     * 定义一个存储定时器ID的变量
     * 在定时器规定事件内如果有重复执行就取消
     * async和await 就是最亲的兄弟 await所在的最近函数加async
     * */
    keyword () {
      this.timer && clearTimeout(this.timer)
      this.timer = setTimeout(async () => {
        console.log('搜索词变化了,' + this.keyword)
        try {
          if (!this.keyword) {
            // 清空联想词列表
            this.suggestList = []
            return
          }
          const { data } = await suggest(this.keyword)
          console.log('联想词列表', data)
          // 小米为null
          if (data.options[0] === null) return
          // 返回数据要把包含关键词不跟使用span包裹 用map映射为包含html标签的字符串 渲染用v-html
          this.suggestList = data.options.map((word) => word.toLowerCase().replace(this.keyword, `<span>${this.keyword}</span>`))
          // es10语法 ? eslint不适用?
          // this.suggestList = data.options.map(words => { words?.tolowerCase().replace(this.keyword, `<span>${this.keyword}</span>`) })
        } catch (error) {
          console.dir(error)
        }
      }, 500)
    }
  }
};
</script>

<style lang="less" scoped>
.container {
  width: 100%;
  height: 100%;
  position: relative;
  .my-wrapper {
    width: 100%;
    height: 100%;
    overflow: hidden;
    padding-top: 10px;
    padding-bottom: 50px;
    box-sizing: border-box;
    &.noTop {
      padding-top: 0;
    }
  }
  .tt-image {
    display: inline-block;
    position: relative;
    .image-container.animate {
      -webkit-transition-property: opacity;
      -o-transition-property: opacity;
      -moz-transition-property: opacity;
      transition-property: opacity;
      -webkit-transition-timing-function: cubic-bezier(0.39, 0.575, 0.565, 1);
      -moz-transition-timing-function: cubic-bezier(0.39, 0.575, 0.565, 1);
      -o-transition-timing-function: cubic-bezier(0.39, 0.575, 0.565, 1);
      transition-timing-function: cubic-bezier(0.39, 0.575, 0.565, 1);
    }
  }
  .half-border {
    position: relative;
    // border-style:;
    border-bottom:1px solid  #ebeaea;
  }
  .all-border-box * {
    -moz-box-sizing: border-box;
    box-sizing: border-box;
  }
  .m-header-wrapper {
    height: 1rem;
    .logo img {
      height: 1rem;
      width: 1rem;
    }
    .m-header-container {
      background-color: #fff;
      left: 0;
      position: fixed;
      right: 0;
      z-index: 10;
      .logo-header-container {
        -moz-box-align: center;
        -webkit-align-items: center;
        align-items: center;
        display: -webkit-flex;
        display: -moz-box;
        display: flex;
        padding: 0.12rem 0.32rem;
      }
    }
    .logo {
      display: -webkit-flex;
      display: -moz-box;
      display: flex;
      margin-right: 0.28rem;
    }
    .search {
      -moz-box-flex: 1;
      -webkit-flex: 1 1;
      flex: 1 1;
      height: 0.88rem;
      position: relative;
      .search-icon {
        background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAMAAABg3Am1AAAAOVBMVEUAAABQUFBQUFBQUFBQUFBQUFBQUFBQUFBQUFBQUFBQUFBQUFBQUFBQUFBQUFBQUFBQUFBQUFBQUFA/VcaaAAAAEnRSTlMA3yDvvxCfgF9AkDBQz3Cwb48IXqpyAAABRElEQVRIx9VVW5KDMAwjdh7kVajuf9ilQ2cKcRzo7M+u/hBSomDHTP8Gjui+OKbK2MA25BtLB8YBZr7Qr7ucjbX1hoUsNtj1nT+vBhueut685PFIzS+qkq7n0rIBgHGa3pDkIwO2Z7C7XiIzECQ9H/TyFXIvkPoBUyfU/OEkHAOx4UxDiU+VmoMBZtQwAJ+ZB/CYBrBtgEUmGi9YATcyFMCfiCajAAFLYzBXBvs7g7mIFNtIFaDhodvKeaCMDKnttLldQXYOidq74RGqrH3QDV72fhxtQb3LZfV54kxve2K1YZ/9sj6gXNIApUgevZ3dm9YcS7NWNLterSfg6SC3gEgqRilqKjHnMvv9NwEwqQ7yOIODs/twVS3JfOR2dXsZ/DRCLsFvCMW9n/US6TMD8StHks00hqty9I5BDJ6+Ql7K9FfxA3hYFHSa2WqwAAAAAElFTkSuQmCC)
        no-repeat 50%;
        background-size: cover;
        height: 0.32rem;
        left: 0.2rem;
        position: absolute;
        top: 0.3rem;
        width: 0.32rem;
      }
    }

    .search-input {
      background-color: #f2f2f2;
      border: none;
      -moz-border-radius: 0.6rem;
      border-radius: 0.6rem;
      -moz-box-sizing: border-box;
      box-sizing: border-box;
      font-size: 0.28rem;
      height: 100%;
      line-height: 0.4rem;
      padding-left: 0.72rem;
      width: 100%;
    }
  }
  .footer{
    font-size: 8px;
    position: fixed;
    bottom: 0;
    width: 100%;
    line-height: var(--footer-height);
    background: #f2f2f2;
    color: #999;
      .logo-title{
        color: #222;
        margin: 4px 6px 4px 30px;
      }
      .beian{
        margin: 4px 6px 16px 30px;
        padding-bottom:10px ;
      }
    }
  
}
</style>
